export enum ApplicationAttributes {
  reactions = 'reactions',
  message_search_v3 = 'message_search_v3',
  enable_og_tag = 'enable_og_tag',
  use_last_seen_at = 'use_last_seen_at',
  enable_message_threading = 'enable_message_threading',
  allow_message_update_from_sdk = 'allow_message_update_from_sdk',
  allow_group_channel_create_from_sdk = 'allow_group_channel_create_from_sdk',
  allow_migration_api = 'allow_migration_api',
  allow_only_operator_sdk_to_update_group_channel_image = 'allow_only_operator_sdk_to_update_group_channel_image',
  allow_user_update_from_sdk = 'allow_user_update_from_sdk',
  allow_broadcast_channel = 'allow_broadcast_channel',
  allow_sdk_file_message_urls = 'allow_sdk_file_message_urls',
  allow_group_channel_leave_from_sdk = 'allow_group_channel_leave_from_sdk',
  allow_user_list_from_sdk = 'allow_user_list_from_sdk',
  allow_group_channel_invite_from_sdk = 'allow_group_channel_invite_from_sdk',
  allow_only_operator_sdk_to_update_group_channel_name = 'allow_only_operator_sdk_to_update_group_channel_name',
  allow_group_channel_update_from_sdk = 'allow_group_channel_update_from_sdk',
  allow_super_group_channel = 'allow_super_group_channel',
  allow_non_operators_to_mention_channel = 'allow_non_operators_to_mention_channel',
  allow_file_messages_from_sdk = 'allow_file_messages_from_sdk',
  allow_open_channel_create_from_sdk = 'allow_open_channel_create_from_sdk',
  allow_anonymous_message_update = 'allow_anonymous_message_update',
  allow_group_channel_delete_from_sdk = 'allow_group_channel_delete_from_sdk',
  allow_operators_to_ban_operators = 'allow_operators_to_ban_operators',
  allow_operators_to_edit_operators = 'allow_operators_to_edit_operators',
}

export enum PremiumFeatures {
  reactions = 'reactions',
  moderation_group = 'moderation_group',
  message_search_v3 = 'message_search_v3',
  data_export = 'data_export',
  migration = 'migration',
  delivery_receipt = 'delivery_receipt',
  auto_thumbnail = 'auto_thumbnail',
  image_moderation = 'image_moderation',
  super_group_channel = 'super_group_channel',
  announcement = 'announcement',
  moderation_open = 'moderation_open',
  desk = 'desk',
  bot_interface = 'bot_interface',
  auto_trans = 'auto_trans',
}
